(function () {
  /* Magnesium Sleep Lotion PDP. Same gallery + review-scroll as the cream page,
     but no Seal / selling plan: prices are read off the jar radios' data attributes
     (data-scp-price / data-scp-compare, in cents) that Liquid fills from the variant. */

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function getSelectedJar(root) {
    return root.querySelector('[data-scp-jar]:checked');
  }

  function updateJarCards(root, selected) {
    Array.prototype.slice.call(root.querySelectorAll('[data-scp-jar-card]')).forEach(function (card) {
      var input = card.querySelector('[data-scp-jar]');
      card.classList.toggle('is-selected', input === selected);
    });
  }

  function syncFormVariant(root, selected) {
    var form = root.querySelector('.scp-form');
    if (!form || !selected) return;
    var variantInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[data-scp-quantity], input[name="quantity"]');
    var variantId = selected.getAttribute('data-scp-variant-id');
    if (variantInput && variantId) variantInput.value = variantId;
    if (qtyInput) qtyInput.value = '1';
  }

  function syncPrices(root, selected) {
    if (!selected) return;
    var price = Number(selected.getAttribute('data-scp-price'));
    var compare = Number(selected.getAttribute('data-scp-compare'));
    var hasDiscount = compare > price;
    var discount = hasDiscount ? Math.round((compare - price) * 100 / compare) : 0;

    Array.prototype.slice.call(root.querySelectorAll('[data-scp-cart-discount]')).forEach(function (pill) {
      pill.textContent = hasDiscount ? discount + '% Off' : '';
    });
  }

  function initGallery(root) {
    var slidesWrap = root.querySelector('[data-scp-slides]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-scp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-scp-thumb]'));
    var current = root.querySelector('[data-scp-current]');
    var progress = root.querySelector('[data-scp-progress]');
    var prev = root.querySelector('[data-scp-gallery-prev]');
    var next = root.querySelector('[data-scp-gallery-next]');
    var active = 0;

    function setActive(index, scroll) {
      active = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === active);
      });
      thumbs.forEach(function (thumb, idx) {
        thumb.classList.toggle('is-active', idx === active);
      });
      if (current) current.textContent = String(active + 1);
      if (progress) progress.style.width = ((active + 1) / Math.max(1, slides.length) * 100) + '%';
      if (scroll && slides[active]) slides[active].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        setActive(index, true);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        setActive((active - 1 + slides.length) % slides.length, false);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        setActive((active + 1) % slides.length, false);
      });
    }

    if (slidesWrap) {
      var ticking = false;
      var isDragging = false;
      var dragStartX = 0;
      var dragStartScrollLeft = 0;

      slidesWrap.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        isDragging = true;
        dragStartX = event.clientX;
        dragStartScrollLeft = slidesWrap.scrollLeft;
        slidesWrap.classList.add('is-dragging');
        if (slidesWrap.setPointerCapture) slidesWrap.setPointerCapture(event.pointerId);
      });

      slidesWrap.addEventListener('pointermove', function (event) {
        if (!isDragging) return;
        event.preventDefault();
        slidesWrap.scrollLeft = dragStartScrollLeft - (event.clientX - dragStartX);
      });

      function endDrag(event) {
        if (!isDragging) return;
        isDragging = false;
        slidesWrap.classList.remove('is-dragging');
        if (slidesWrap.releasePointerCapture) {
          try {
            slidesWrap.releasePointerCapture(event.pointerId);
          } catch (error) {}
        }
      }

      slidesWrap.addEventListener('pointerup', endDrag);
      slidesWrap.addEventListener('pointercancel', endDrag);
      slidesWrap.addEventListener('pointerleave', endDrag);

      slidesWrap.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var item = slides[0];
          if (!item) return;
          var gap = 8;
          var index = Math.round(slidesWrap.scrollLeft / (item.getBoundingClientRect().width + gap));
          setActive(index, false);
          ticking = false;
        });
      }, { passive: true });
    }

    setActive(0, false);
  }

  function initReviewScroll(root) {
    var trigger = root.querySelector('[data-scp-review-scroll]');
    if (!trigger) return;

    function findReviewsTarget() {
      return document.querySelector('.jdgm-review-widget') ||
        document.querySelector('.jdgm-widget:not(.jdgm-preview-badge)') ||
        document.querySelector('[id^="shopify-section-template--"][id*="__177931204779f08099"]');
    }

    function scrollToReviews() {
      var target = findReviewsTarget();
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    trigger.addEventListener('click', scrollToReviews);
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        scrollToReviews();
      }
    });
  }

  function initRoot(root) {
    initGallery(root);
    initReviewScroll(root);

    var form = root.querySelector('.scp-form');
    if (!form) return;

    root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-scp-jar]')) return;
      var selected = event.target;
      updateJarCards(root, selected);
      syncFormVariant(root, selected);
      syncPrices(root, selected);
    });

    var selected = getSelectedJar(root);
    if (selected) {
      updateJarCards(root, selected);
      syncFormVariant(root, selected);
      syncPrices(root, selected);
    }

    // Belt and braces: make sure the submitted variant is the selected card.
    document.addEventListener('submit', function (event) {
      if (event.target !== form) return;
      syncFormVariant(root, getSelectedJar(root));
      var planInput = form.querySelector('input[name="selling_plan"]');
      if (planInput) planInput.value = '';
    }, true);
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('.scp-root--lotion')).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
